import api from './api';

export const getCities = () => api.get('/api/map/cities');
export const getZones = (cityId) => api.get(`/api/map/cities/${cityId}/zones`);
export const getNearbyPOIs = (lat, lng, radius = 500) => api.get('/api/map/pois/nearby', { params: { lat, lng, radius } });
export const getSuggestedPOIs = (lat, lng) => api.get('/api/map/pois/suggested', { params: { lat, lng } });
export const collectPOI = (poiId, lat, lng, accuracy = 0, multiplier = 1) => api.post(`/api/map/pois/${poiId}/collect`, { lat, lng, accuracy, multiplier });
export const getPOIsByCity = (cityId, lat, lng) => api.get(`/api/map/pois/city/${cityId}`, { params: { lat, lng } });
